<!--
  - Copyright (c) 2024. Haodong JU
  -->

<template>
  <v-card
    v-if="show"
    class="pa-4"
    elevation="0"
  >
    <page-sub-header class="mb-6">
      <slot />
      <template #subtitle>
        <slot name="subtitle" />
      </template>
      <template #action>
        <v-btn
          v-if="isDialog"
          class="mr-2"
          elevation="0"
          @click="closeDialog"
        >
          <v-icon left>
            mdi-close
          </v-icon>
          {{ $t('closed') }}
        </v-btn>
        <v-btn
          :disabled="!formValid || !canEdit"
          color="amber lighten-4 black--text"
          elevation="0"
          @click="submit"
        >
          <v-icon left>
            mdi-content-save
          </v-icon>
          {{ $t('save') }}
        </v-btn>
      </template>
    </page-sub-header>

    <v-form
      v-if="!reloading"
      ref="form"
      v-model="formValid"
      lazy-validation
    >
      <div>
        <div
          v-for="(f,index) in fields"
          :key="index"
        >
          <div class="d-flex">
            <div
              class="text-body-1 mr-2"
              style="width: 50%;"
            >
              <div class="font-weight-bold">
                {{ $t(f.name) }}<span v-if="f.required">*</span>
              </div>
              <div class="text-body-2">
                {{ $t(f.hint) }}
              </div>
            </div>
            <v-spacer />
            <div
              class="d-flex align-start justify-center"
              style="width: 50%;"
            >
              <component
                :is="f.component"
                v-model="holderObject[f.key]"
                dense
                v-bind="f.componentProps"
              />
              <v-icon
                v-if="f.componentProps?.iconAppend"
                class="mt-2 ml-1"
                @click="f.componentProps?.iconAppend.onClick()"
              >
                {{ f.componentProps.iconAppend.icon }}
              </v-icon>
            </div>
          </div>
        </div>
      </div>
    </v-form>
  </v-card>
</template>

<script>

import { mapSchemaToField } from '@/views/widget/INK/BaseForm/baseFormUtils'
import PageSubHeader from '@/views/widget/typography/PageSubHeader.vue'

export default {
  name: 'BaseForm',
  components: { PageSubHeader },
  props: {
    canEdit: {
      type: Boolean,
      default: true
    },
    isDialog: {
      type: Boolean,
      default: true
    },
    schema: {
      type: Array,
      default: () => []
    },
    editingObject: {
      type: Object,
      required: false,
      default: () => null
    },
    loading: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      reloading: false,
      formValid: null,
      holderObject: {}
    }
  },
  methods: {
    closeDialog () {
      this.$emit('close')
      this.reset()
    },
    submit () {
      if (this.$refs.form.validate()) {
        this.$emit('submit', this.holderObject)
      }
    },
    reset () {
      this.reloading = true
      if (this.editingObject) {
        this.holderObject = Object.assign({}, this.editingObject)
      } else {
        this.holderObject = Object.fromEntries(this.schema.map(it => [it.key, it.default]))
      }
      this.reloading = false
    }
  },
  watch: {
    schema: {
      deep: true,
      immediate: true,
      handler (val) {
        this.reset()
      }
    },
    show (val) {
      if (val) {
        this.reset()
      }
    },
    editingObject: {
      deep: true,
      immediate: true,
      handler (val) {
        this.$nextTick(() => {
          this.reset()
        })
      }
    }
  },
  computed: {
    fields () {
      return this.schema.map(mapSchemaToField)
    }
  }
}
</script>

<style scoped>

</style>
